import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export const useUnFollowTeacher = () =>
  useMutation({
    mutationFn: async (teacherId?: number) => {
      const { data } = await $apiV2.delete(`/follow/unfollow`, { data: { teacher_id: teacherId } });

      return data;
    },
    onError: errorHandler()
  });
